import React from "react";
import { connect } from "react-redux";
import * as actionTypes from "../../../store/actions";

import RuleSideBarItem from "./RuleSideBarItem";
import useWindowDimensions from "../../../WindowDimensions-hook/useWindowDimensions";

const RulesSideBar = (props) => {
  const { height } = useWindowDimensions();
  return (
    <div className="side-bar-tickets">
      <div className="side-bar-scroll" style={{ maxHeight: height }}>
        <div className="ticket-item-head">{props.rulesArray.rules.name}</div>
        {props.rulesArray.rules.items.map((rule, index) => (
          <RuleSideBarItem
            closeSideBarMobile={props.closeSideBarMobile}
            header={rule.name}
            key={index}
            type={"rules"}
            ruleId={rule.id}
            rulesArray={props.rulesArray}
            isActiveTicketItem={
              parseInt(props.paramsRuleId) === rule.id &&
              props.rulesType === "rules"
            }
          />
        ))}
        <div className="ticket-item-head">{props.rulesArray.signs.name}</div>

        {props.rulesArray.signs.items.map((sign, index) => (
          <RuleSideBarItem
            closeSideBarMobile={props.closeSideBarMobile}
            header={sign.name}
            key={index}
            type={"signs"}
            ruleId={sign.id}
            rulesArray={props.rulesArray}
            isActiveTicketItem={
              parseInt(props.paramsRuleId) === sign.id &&
              props.rulesType === "signs"
            }
          />
        ))}
        <div className="ticket-item-head">{props.rulesArray.marks.name}</div>

        {props.rulesArray.marks.items.map((mark, index) => (
          <RuleSideBarItem
            closeSideBarMobile={props.closeSideBarMobile}
            header={mark.name}
            key={index}
            type={"marks"}
            ruleId={mark.id}
            rulesArray={props.rulesArray}
            isActiveTicketItem={
              parseInt(props.paramsRuleId) === mark.id &&
              props.rulesType === "marks"
            }
          />
        ))}
        <div className="ticket-item-head">{props.rulesArray.access.name}</div>

        {props.rulesArray.access.items.map((acc, index) => (
          <RuleSideBarItem
            closeSideBarMobile={props.closeSideBarMobile}
            header={acc.name}
            key={index}
            type={"access"}
            ruleId={acc.id}
            rulesArray={props.rulesArray}
            isActiveTicketItem={
              parseInt(props.paramsRuleId) === acc.id &&
              props.rulesType === "access"
            }
          />
        ))}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    paramsRuleId: state.router.location.pathname.split("/")[2],
    rulesType: state.router.location.pathname.split("/")[1],
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    setRulesArray: (ticketsArray) =>
      dispatch({
        type: actionTypes.SET_TICKETS_ARRAY,
        ticketsArray: ticketsArray,
      }),
    setLoadedRule: (loadedBilet) =>
      dispatch({
        type: actionTypes.SET_LOADED_BILET,
        loadedBilet: loadedBilet,
      }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RulesSideBar);
